import classNames from "classnames"
import type {
  HTMLAttributes,
  Ref,
} from "react"
import { forwardRef } from "react"
import styles from "./TileTimeValue.module.scss"
import { round } from "src/utils"

export interface TileTimeValueProps extends HTMLAttributes<HTMLDivElement> {
  timeInMinutes: number | null;
  tileId: string;
  dayAbbreviation?: string; // if dayAbbreviation is omitted only use hours and minutes
  hourAbbreviation: string;
  minuteAbbreviation: string;
}

const oneDayInMinutes = 24 * 60

export const TileTimeValue = forwardRef<HTMLDivElement, TileTimeValueProps>(
  function TileTimeValue(props: TileTimeValueProps, propRef: Ref<HTMLDivElement>) {
    const {
      dayAbbreviation,
      hourAbbreviation,
      minuteAbbreviation,
      timeInMinutes,
      tileId,
      ...divProps
    } = props

    const valueInMinutes = round(timeInMinutes === null || isNaN(timeInMinutes) ? 0 : timeInMinutes)

    const minutes = valueInMinutes % 60
    const days = dayAbbreviation === undefined ? 0 : Math.floor(valueInMinutes / oneDayInMinutes)
    const hours = (valueInMinutes - days * oneDayInMinutes - minutes) / 60

    const className = classNames(
      props.className,
      styles.container,
    )

    return (
      <div
        {...divProps}
        className={className}
        ref={propRef}
      >
        {!!days && (
          <div className={styles.valueUnit}>
            <div className={styles.value}>
              {days}
            </div>
            <div
              className={styles.unit}
              id={`${tileId}-unit`}
            >
              {dayAbbreviation}
            </div>
          </div>
        )}
        {!!hours && (
          <div className={styles.valueUnit}>
            <div className={styles.value}>
              {hours}
            </div>
            <div
              className={styles.unit}
              id={`${tileId}-unit`}
            >
              {hourAbbreviation}
            </div>
          </div>
        )}
        {(!!minutes || (!hours && !days)) && (
          <div className={styles.valueUnit}>
            <div className={styles.value}>
              {timeInMinutes === null ? "--" : minutes}
            </div>
            <div
              className={styles.unit}
              id={`${tileId}-unit`}
            >
              {minuteAbbreviation}
            </div>
          </div>
        )}
      </div>
    )
  },
)
